module.exports = "/static/assets/e7c972c634096b89b182b99441a20b1d.svg";